module.exports = __webpack_public_path__ + "icon_oikeus.8004de731579b6ff0409.svg";